import { FC, useState, useMemo } from 'react';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { updateOpen } from '../store/dialog';

// assets
import style from '../assets/style/layout/dialog.module.scss';

// component
import { Bounce } from '../components/bounce';

// function component
export const Dialog: FC = () => {
  const dispatch = useDispatch();

  const { isOpen, content } = useSelector((state: RootState) => state.dialog);
  const classList = useSelector((state: RootState) => state.dialog.class);

  const [parentClass, setParentClass] = useState<string[]>([style.dialog]);

  useMemo(() => {
    setParentClass(isOpen ? [style.dialog, style.isOpen] : [style.dialog]);
  }, [isOpen]);

  return (
    <div className={parentClass.join(' ')}>
      <div className={style.screen}></div>
      <div className={[style.content, style.basic, ...classList].join(' ')}>
        <div className={style.detail}>
          {content}
          <Bounce
            className={style.button}
            type="button"
            onClick={() => dispatch(updateOpen(false))}
          >
            OK
          </Bounce>
        </div>
        <button
          className={style.close}
          type="button"
          onClick={() => dispatch(updateOpen(false))}
        ></button>
      </div>
    </div>
  );
};
